import React, { useState, useContext } from 'react'
import styles from './index.module.less'
import Dialog from '../common/dialog'

import context from '../../context'

interface IProps {
  /**
   * 本月预计回佣金额
   */
  curMonthWillRewardAmt?: string
  /**
   * 累计奖励金额
   */
  rewardAmt?: string
  /**
   * 金额币种
   */
  currency?: string
  /**
   * 金额币种符号
   */
  currencySymbol?: string
}

const Reward = (props: IProps) => {
  const { reward } = useContext(context)
  const { commissions, received } = reward
  const { currencySymbol, curMonthWillRewardAmt, rewardAmt } = props

  const [visible, setVisible] = useState(false)
  const [tips, setTips] = useState({ head: '', content: '' })

  const handle = (type: 'commissions' | 'received') => {
    setTips(reward[type].tips)
    setVisible(true)
  }
  return (
    <>
      <div className={styles.reward}>
        <div className={styles.commissions}>
          <div>
            <span className={styles.title}>{commissions.title}</span>
            <em className={styles.declare} onClick={() => handle('commissions')} />
          </div>
          <div>
            <span className={styles.currency}>{currencySymbol}</span>
            <span className={styles.figure}>{curMonthWillRewardAmt}</span>
          </div>
        </div>
        <div className={styles.award}>
          <div>
            <span className={styles.title}>{received.title}</span>
            <em className={styles.declare} onClick={() => handle('received')} />
          </div>
          <div>
            <span className={styles.currency}>{currencySymbol}</span>
            <span className={styles.figure}>{rewardAmt}</span>
          </div>
        </div>
      </div>
      <Dialog
        visible={visible}
        title={tips.head}
        content={tips.content}
        callback={() => {
          setVisible(false)
        }}
      />
    </>
  )
}

export default Reward
